import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid2,
  Paper,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import clock from "../../assets/clock.png";
import user from "../../assets/users.png";
import {
  cancelReservation,
  getReservationDetails,
  getWidgetSettings,
} from "../../api/HorecaWidget.service";
import { useDispatch, useSelector } from "react-redux";
import {
  setLanguageWords,
  setReservationDetail,
} from "../../store/slice/Addguest.slice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { updateCss, updateWidgetSetting } from "../../store/slice/widgetSetting.slice";
import { STATUSTYPEIDS } from "../../constants/moduleTypes";

const CancelReservation = () => {
  const theme = useTheme();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const moduleId=queryParams.get('mainModuleId')
  const{css}=useSelector((store)=> store?.widgetSettings)
  const Css = css?.find((item) => item?.cssTabFieldsGroupName === "Success and cancel")?.fields;
  const key = queryParams.get("key");
  const secretKey = queryParams.get("secretkey");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState();
  const [isFetching, setIsFetching] = useState(false);
  const { ReservationDetail } = useSelector((store) => store?.addGuest);
  const [reasonError, setReasonError] = useState(false);
  const { WidgetSetting, widgetConfig } = useSelector(
    (store) => store?.widgetSettings
  );
  const { languageWords } = useSelector((store) => store?.addGuest);
  const [isChecked, setIsChecked] = useState(true);
  const [error, setError] = useState(false);
  const [reason, setReason] = useState("");
  const DATE = dayjs(ReservationDetail?.arrivalDate).format("DD-MM-YYYY");
  const originalDate = dayjs(DATE, "DD-MM-YYYY");

  const day = originalDate.date();
  const month = originalDate.month() + 1;
  const year = originalDate.year();
  const map = {
    1: languageWords?.January,
    2: languageWords?.February,
    3: languageWords?.March,
    4: languageWords?.April,
    5: languageWords?.May,
    6: languageWords?.June,
    7: languageWords?.July,
    8: languageWords?.August,
    9: languageWords?.September,
    10: languageWords?.October,
    11: languageWords?.November,
    12: languageWords?.December,
  };
  const grandTotal =
    (Number(ReservationDetail?.adults) || 0) +
    (Number(ReservationDetail?.kid) || 0) +
    (Number(ReservationDetail?.child) || 0) +
    (Number(ReservationDetail?.toddler) || 0) +
    (Number(ReservationDetail?.baby) || 0);
  const formattedDate = `${day} ${map[month]} ${year}`;

  const dispatch = useDispatch();
  const fetchReservation = async () => {
    setIsFetching(true);
    try {
      const response = await getReservationDetails(key, secretKey,moduleId);
      if (response?.status != 200) {
        setError(true);
        throw new Error("Failed to fetch reservation details");
      } else {
        const result = response?.data?.basicLanguages?.reduce((acc, item) => {
          const tag = item.tag.replace(/{|}/g, "").replace(/\s+/g, "");
          const data = item.widgetTranslateLanguages[0]?.name;
          acc[tag] = data; // Assign data to the key acc[tag]
          return acc;
        }, {});
        dispatch(updateCss(response?.data?.settings?.cssGroup))
        dispatch(setLanguageWords(result));
        dispatch(setReservationDetail(response?.data));
      }
    } catch (error) {
      setIsFetching(false);
      console.error("Error fetching reservation details:", error?.message);
    }
  };
  const fetchWidgetSettings = async (language) => {
    try {
      const response = await getWidgetSettings(language, key);
      if (response?.status != 200 || !response?.data) {
        throw new Error("Failed to fetch widget settings");
      }
      dispatch(updateWidgetSetting(response?.data));
      setIsFetching(false);
    } catch (error) {
      setIsFetching(false);
      console.error("Error fetching widget settings:", error?.message);
    }
  };
  const handleCancelReservation = async () => {
    if (!reason.trim()) {
      setReasonError(true);
      return;
    }

    setReasonError(false);
    setIsLoading(true);

    const payload = {
      key: key,
      secretKey: secretKey,
      remarks: reason,
    };

    try {
      const response = await cancelReservation(key, secretKey, payload);
      if (response?.status == 200) {
        navigate("/ReservationCancelSuccess");
      } else {
        alert("Error canceling reservation");
      }
    } catch (error) {
      console.error("Error canceling reservation:", error?.message);
    }

    setIsLoading(false);
  };


  const send = (
    frameHeight,
    frameWidth,
    top,
    right,
    bottom,
    left,
    floating,
    redirectUrl
  ) => {
    window.parent.postMessage(
      {
        reservationIframeHeight: frameHeight,
        reservationIframeWidth: frameWidth,
        reservationIframePositionTop: top,
        reservationIframePositionRight: right,
        reservationIframePositionBottom: bottom,
        reservationIframePositionLeft: left,
        reservationIframePositionFloating: floating,
        redirectUrl: redirectUrl,
      },
      "*"
    );
  };

  useEffect(() => {
    let parentUrl = document.referrer;
    if (!parentUrl) {
      const { origin, pathname, search, hash } = window.location;
      parentUrl = `${origin}${pathname}${search}${hash}`;
    }

    localStorage.setItem("parentUrl", parentUrl);
  }, []);
  useEffect(() => {
    document.body.setAttribute(
      "style",
      "background-color:  rgb(249, 249, 249) !important"
    );
    fetchReservation();
  }, []);
  useEffect(() => {
    if (ReservationDetail) {
      fetchWidgetSettings(ReservationDetail?.language?.slice(-2));
    }
  }, [ReservationDetail]);

  if (isFetching && !ReservationDetail) {
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={isFetching}
        onClick={() => setIsFetching(false)}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  if (error) {
    return (
      <Box
        sx={{
          width: "100%",
          p: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Box sx={{ mt: 2 }}>
          <Typography
            sx={{
              color: theme?.widget?.cancelMessageColor,
              fontWeight: "regular",
              fontSize: "1.5rem",
            }}
          >
            Failed to Fetch Cancel Reservation details.
          </Typography>
        </Box>
      </Box>
    );
  }
  if (ReservationDetail?.idstatus != STATUSTYPEIDS?.OPEN) {
    return (
      send("100vh", "100%", "", "0px", "0px", "", "fixed"),
      (
        <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f9fafb",
          p: 2,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            maxWidth: 500,
            width: "100%",
            p: 4,
            borderRadius: "20px",
            textAlign: "center",
            backgroundColor: theme?.widget?.cancelBgColorCards ?? "#fff",
            boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
          }}
        >
          <Box
            sx={{
              width: 70,
              height: 70,
              margin: "0 auto",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #FFE8E8, #FFD6D6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "30px",
            }}
          >
            ❌
          </Box>
  
          <Typography
            sx={{
              mt: 3,
              fontSize: "20px",
              fontWeight: 700,
              color: theme?.widget?.cancelHeadingColor ?? "#111827",
            }}
          >
            Cancellation Not Allowed
          </Typography>
  
          <Typography
            sx={{
              mt: 1.5,
              fontSize: "14px",
              color: theme?.widget?.cancelInfoColor ?? "#6B7280",
            }}
          >
              This reservation cannot be cancelled at this time. 
          Please contact the service provider directly for further assistance.
          </Typography>
        </Paper>
      </Box>
      )
   
    );


  
  }
  return (
    send("100vh", "100%", "", "0px", "0px", "", "fixed"),
    (
      <Box sx={{ width: "100%", p: { xs: 1, md: 3 } }}>
        <Box sx={{ mb: 4 }}>
          <Typography
            sx={{
              fontSize: { md: "24px", sm: "12", xs: "14px" },
              fontWeight: 700,
              color:Css?.cancelHeading,
            }}
          >
            {languageWords?.CancelReservation}
          </Typography>

          <Typography
            sx={{
              mt: 1,
              fontSize: { md: "16px", sm: "12px", xs: "12px" },
              color: Css?.cancelInfo,
              maxWidth: "640px",
            }}
          >
            {languageWords?.CancelInfo}
          </Typography>
        </Box>
        <Grid2 container spacing={3}>
          <Grid2 size={{ md: 6, sm: 12, xs: 12 }}>
            <Box
              sx={{
                backgroundColor: Css?.cancelYourBookingBgClr,
                borderRadius: "20px",
                border:`1px solid ${Css?.cancelYourBookingBorderClr}`,
                p: 3,
                boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: Css?.cancelYourBookingHeadingClr,
                }}
              >
                {languageWords?.yourBooking}
              </Typography>

              <Box sx={{ mt: 2 }}>
                <Typography sx={{ fontSize: "22px", fontWeight: 600,color: Css?.cancelYourBookingAddressHeadingClr}}>
                  {
                    WidgetSetting?.find((item) => item?.tag === "companyName")
                      ?.data
                  }
                </Typography>
                <Typography
                  sx={{ color: Css?.cancelYourBookingAddressInfoClr, fontSize: "13px" }}
                >
                  {
                    WidgetSetting?.find(
                      (item) => item?.tag === "companyAddress"
                    )?.data
                  }
                  ,{" "}
                  {
                    WidgetSetting?.find((item) => item?.tag === "companyCity")
                      ?.data
                  }
                </Typography>
              </Box>

              {/* Meta Info */}
              <Box
                sx={{
                  display: "flex",
                  gap: 3,
                  alignItems: "center",
                  mt: 3,
                  flexWrap: "wrap",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img src={clock} alt="time" width={24} />
                  <Typography
                    sx={{ color: Css?.cancelDateTimeClr }}
                  >
                    {formattedDate}{" "}
                    {ReservationDetail?.arrivalTime?.substring(0, 5)}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img src={user} alt="user" width={24} />
                  <Typography sx={{ color:Css?.cancelCountClr }}>
                    {grandTotal}
                  </Typography>
                </Box>
              </Box>

              {/* Price */}
              {ReservationDetail?.reservationPrice && (
                <Box
                  sx={{
                    mt: 4,
                    p: 2,
                    borderRadius: "14px",
                    background: "linear-gradient(135deg, #FFF5EC, #FFE4D2)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: Css?.cancelReservationPriceClr,
                    }}
                  >
                    {ReservationDetail?.reservationType?.name}
                  </Typography>
                  <Typography sx={{ fontWeight: 700, color: Css?.cancelReservationPriceClr }}>
                    €{" "}
                    {parseFloat(
                      ReservationDetail?.reservationType?.maxamount
                    ).toFixed(2)}
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid2>
          <Grid2 size={{ md: 6, sm: 12, xs: 12 }}>
            <Box
              sx={{
                backgroundColor: Css?.cancelGuestCardBgClr,
                borderRadius: "20px",
                border:`1px solid ${Css?.cancelBorderClr}`,
                p: 3,
                boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: Css?.cancelYourBookingHeadingClr,
                }}
              >
                {languageWords?.yourDetails}
              </Typography>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "120px 1fr",
                  rowGap: 1.5,
                  mt: 3,
                }}
              >
                <Typography fontWeight={500} sx={{color:Css?.cancelLabelText}}>{languageWords?.Name}</Typography>
                <Typography color={Css?.cancelGuestTextClr}>
                  {ReservationDetail?.name}
                </Typography>

                <Typography fontWeight={500} sx={{color:Css?.cancelLabelText}}>{languageWords?.Email}</Typography>
                <Typography color={Css?.cancelGuestTextClr}>
                  {ReservationDetail?.email}
                </Typography>

                <Typography fontWeight={500} sx={{color:Css?.cancelLabelText}}>{languageWords?.Phone}</Typography>
                <Typography color={Css?.cancelGuestTextClr}>
                  {ReservationDetail?.phone}
                </Typography>
              </Box>
            </Box>
          </Grid2>
        </Grid2>
        <Grid2 container spacing={3} mt={2}>
          <Grid2 size={{ md: 6, sm: 12, xs: 12 }}>
            <TextField
              multiline
              rows={6}
              fullWidth
              value={reason}
              placeholder={languageWords?.ReasonforCancellation}
              onChange={(e) => {
                setReason(e.target.value);
                if (e.target.value.trim()) {
                  setReasonError(false);
                }
              }}
              error={reasonError}
              helperText={reasonError ? "Reason is required" : ""}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "16px",
                  border:`1px solid ${Css?.cancelYourBookingBorderClr}`,
                 
                },
              }}
            />
          </Grid2>
        </Grid2>
        <Grid2 container spacing={2} mt={2}>
          <Grid2 size={{ md: 12, sm: 12 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                  sx={{
                    "&.Mui-checked": { color: Css?.cancelCheckboxTickColor },
                  }}
                />
              }
              label={
                <Typography sx={{ color: Css?.cancelLabelCheckBoxClr}}>
                  {languageWords?.TermsandCondtionsText}
                </Typography>
              }
            />

            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button
                //  disabled={!isChecked}
                disabled={!isChecked || !reason.trim()}
                onClick={handleCancelReservation}
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: "12px",
                  backgroundColor: isChecked
                    ? Css?.CancelReservationBgClr 
                    : Css?. CancelReservationDisabledBgClr,
                  color: isChecked
                    ? Css?.cancelReservationTxtClr 
                    : Css?.CancelReservationDisabledTxtClr ,
                  fontWeight: 600,
                 
                }}
              >
                {isLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : (
                  languageWords?.CancelWidgetButtonText
                )}
              </Button>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    )
  );
};

export default CancelReservation;
